<div fxLayout="column" style="padding: 0 !important; overflow-y: overlay;" fxFlex="grow">
  <div fxLayout="row" fxFlex="grow" style="width:100%; margin-top:20px; padding:15px;">
    <div fxLayoutAlign="start center center" fxFlex="20" style="color: var(--primary); font-family: 'Century Gothic', sans-serif; font-size: 18px; font-weight: bold"><mat-icon (click)="close()">close</mat-icon></div>
    <div fxLayoutAlign="start center center" fxFlex="80" style="color: var(--primary); font-family: 'Century Gothic', sans-serif; font-size: 18px; font-weight: bold">{{title}}</div>
  </div>

  <div fxLayout="row" fxFlex="grow" style="width:100%; margin-top:40px; padding:15px;">
    <div fxLayoutAlign="end center center" fxFlex="grow" style=" color: var(--primary); font-family: 'Century Gothic', sans-serif; font-size: 12px; font-weight: bold;" (click)="readAll()">Σήμανση όλων ως αναγνωσμένα</div>
  </div>

  <div fxLayout="column" style="margin-top:30px; width:100%;">
    <div fxFlex="grow" fxLayout="row" *ngFor="let announcement of announcements" style="height:80px; border-bottom: 1px solid lightgray;" [ngStyle]="{'background-color': (announcement.is_opened === 0) ? 'whitesmoke' : 'transparent'}"
         (swipeleft)="onSwipeLeft($event,-1)" (swiperight)="onSwipeRight($event,1)"
         (click)="displayAnnouncement(announcement)">

      <div fxLayoutAlign="center center center" fxFlex="10"><mat-icon>fiber_manual_record</mat-icon></div>
      <div fxLayout="column" fxFlex="75" fxLayoutAlign="center">
<!--        <div fxLayout="row" style="color: var(&#45;&#45;primary); font-size: 16px; font-weight: bold;">{{announcement.title}}</div>-->
        <div fxLayout="row" style="color: var(--primary); font-size: 12px; font-weight: normal;">{{ mode === 0 ? announcement.title : announcement.description}}</div>
        <div></div>
      </div>
      <div *ngIf="mode === 0" fxLayoutAlign="center center center" fxFlex="15">{{announcement.sent}}</div>


    </div>
  </div>
</div>
